
/* injects from baggage-loader */

'use strict';

export default class SettingsController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/settings/settings.controller.js